import React,{useContext } from 'react';
import { SoftSkillsContext } from '../contexts/softSkills';
import Loading from './Loading';


export default function Skills() {
    const softSkillsCtx = useContext(SoftSkillsContext);
    const {softSkills,loading} = softSkillsCtx
   
    const personalSkills = [
        'Fast Learner',
        'Very Good Worker in Team and sharing knowledge',
        'Problem solver',
        'Keen and interested in technologies and innovation',
        'Attention to details',
        'Analytical thinking',
    ]
    return (
        
                <div className='progressSkills'>
                    <p>Every day i'm learn and put new skill here</p>
                    <div className='soft-skills'>
                        {

                        loading ?  <Loading/> : softSkills.map((item,index) => {
                            return(
                                <div key={index} className='soft-skills--card'>
                                    <span>{item.name}</span>
                                    <img src={item.logo.fields.file.url} alt={item.logo.fields.title}/>
                                </div> 
                            )
                        })
                        }
                       
                    </div>
                    <div className='personal-skills'>
                        <h1>Personal Skills</h1>
                        <ul>
                            {
                                loading ? <Loading/> : personalSkills.map((item,index)=>{
                                    return(
                                        <li>
                                            {item}
                                        </li>
                                    )
                                })
                            }
                        </ul>

                    </div>   
                </div>
    )
}
